import View from "../framework/view";
import Server from "../server";
import template from "../../pugc/products";
import {Product} from "../bo/product";
import jQuery from "jquery";


export class ProductsView extends View {

    static classname = "products-view";

    private readonly server = Server.instance();

    private products : Product[] | undefined;

    private useProductId : string | undefined;

    private checked : Product[] | undefined;

    constructor() {
        super(ProductsView.classname);
        this.refresh();
    }

    refresh() {
        const shop_ = this.server.getShopProducts();
        shop_.then((products) => {

            products = products.sort((a, b) => (a.name || "").localeCompare(b.name || ""));

            this.products = products;
            this.update();
        });

        /*
        const status_ = this.server.getProductsStatus();
        status_.then((products) => {
            this.checked = products;
            this.update();
        });

         */
    }

    private applyFilter() {
        this.update();
    }

    protected render0(): JQuery<HTMLElement> {

        const data = {
            products: this.products,
            checked: this.checked,
            useProductId: this.useProductId,
        };

        return this.pug(template, data);
    }

    updateVariants(id: string) {
        const update_ = this.server.updateVariants(id, this.useProductId);
        update_.then((product) => {
            if (this.checked) {
                for (const i in this.checked) {
                    if (this.checked[i].id === product.id) {
                        this.checked[i] = product;
                    }
                }
            }
            this.update();
        });
    }

    useSelectedProduct() {
        const s = this.elt().find("select[name='useproduct'");
        const id = s.val() as string;
        this.useProductId = id;
        const status_ = this.server.getProductsStatus(this.useProductId);
        status_.then((products) => {
            products = products.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
            this.checked = products;
            this.update();
        });
    }
}

View.on(
    "." + ProductsView.classname,
    "click",
    ".use-product",
    function(that: ProductsView, event, elt) {
        event.preventDefault();
        that.useSelectedProduct();
    });


View.on(
    "." + ProductsView.classname,
    "click",
    ".update-product",
    function(that: ProductsView, event, elt) {
        event.preventDefault();
        const id = jQuery(elt).data("id") as string;
        that.updateVariants(id);
    });

View.on(
    "." + ProductsView.classname,
    "click",
    ".show-variants",
    function(that: ProductsView, event, elt) {
        event.preventDefault();
        jQuery(elt).closest(".variants").find(".variants-hidden").toggle();
    });
